/*
 *
 * App constants
 *
 */
import { getPractice } from "utils/practiceStorage";

export const DEFAULT_ACTION = "app/App/DEFAULT_ACTION";

const scope = "app/App/";

/**
 * Get planned timeSlots
 */
export const GET_PLANNED_TIMESLOTS = "app/App/GET_PLANNED_TIMESLOTS";
export const GET_PLANNED_TIMESLOTS_FAILED =
  "app/App/GET_PLANNED_TIMESLOTS_FAILED";
export const GET_PLANNED_TIMESLOTS_SUCCESS =
  "app/App/GET_PLANNED_TIMESLOTS_SUCCESS";

export const REMOVE_TIME_SLOT = "app/App/REMOVE_TIMESLOT";

/**
 * Filter patients
 */
export const FILTER_PATIENTS_ACTION = "app/Dashboard/FILTER_PATIENTS_ACTION";
export const FILTER_PATIENTS_SUCCESS_ACTION =
  "app/Dashboard/FILTER_PATIENTS_SUCCESS_ACTION";
export const FILTER_PATIENTS_FAILED_ACTION =
  "app/Dashboard/FILTER_PATIENTS_FAILED_ACTION";

/**
 * Filter dentist
 */
export const FILTER_DENTIST = "app/DentistOverviewPage/FILTER_DENTIST";
export const FILTER_DENTIST_SUCCESS =
  "app/DentistOverviewPage/FILTER_DENTIST_SUCCESS";
export const FILTER_DENTIST_FAILED =
  "app/DentistOverviewPage/FILTER_DENTIST_FAILED";

/**
 * reset dentist
 */
export const RESET_DENTISTS = "app/App/RESET_DENTISTS";

/**
 * Get end products
 */
export const GET_END_PRODUCTS = "app/NewTreatmentPage/GET_END_PRODUCTS";
export const GET_END_PRODUCTS_FAILED =
  "app/NewTreatmentPage/GET_END_PRODUCTS_FAILED";
export const GET_END_PRODUCTS_SUCCESS =
  "app/NewTreatmentPage/GET_END_PRODUCTS_SUCCESS";

export const RESET_PATIENTS = "app/App/RESET_PATIENTS";

/**
 * get Dentist
 */

export const GET_DENTISTS_ACTION = "app/NewTreatmentPage/GET_DENTISTS_ACTION";
export const GET_DENTISTS_FAILED_ACTION =
  "app/NewTreatmentPage/GET_DENTISTS_FAILED_ACTION";
export const GET_DENTISTS_SUCCESS_ACTION =
  "app/NewTreatmentPage/GET_DENTISTS_SUCCESS_ACTION";

/**
 * get Insurers
 */

export const GET_INSURERS_ACTION = "app/NewTreatmentPage/GET_INSURERS_ACTION";
export const GET_INSURERS_FAILED_ACTION =
  "app/NewTreatmentPage/GET_INSURERS__FAILED_ACTION";
export const GET_INSURERS_SUCCESS_ACTION =
  "app/NewTreatmentPage/GET_INSURERS_SUCCESS_ACTION";

/**
 * Single practice
 */
export const SET_SINGLE_PRACTICE = "app/App/SET_SINGLE_PRACTICE";

/**
 * Create patient
 */
export const CREATE_PATIENT_ACTION = "app/App/CREATE_PATIENT_ACTION";
export const CREATE_PATIENT_SUCCESS_ACTION =
  "app/App/CREATE_PATIENT_SUCCESS_ACTION";
export const CREATE_PATIENT_FAILED_ACTION =
  "app/App/CREATE_PATIENT_FAILED_ACTION";

/**
 * Create dentist
 */
export const CREATE_DENTIST_ACTION = "app/App/CREATE_DENTIST_ACTION";
export const CREATE_DENTIST_FAILED_ACTION =
  "app/App/CREATE_DENTIST_FAILED_ACTION";
export const CREATE_DENTIST_SUCCESS_ACTION =
  "app/App/CREATE_DENTIST_SUCCESS_ACTION";

/**
 * Delete dentist failed
 */
export const DELETE_DENTIST_ACTION = "app/App/DELETE_DENTIST_ACTION";
export const DELETE_DENTIST_FAILED_ACTION =
  "app/App/DELETE_DENTIST_FAILED_ACTION";
export const DELETE_DENTIST_SUCCESS_ACTION =
  "app/App/DELETE_DENTIST_SUCCESS_ACTION";

export const RESET_DELETE_MESSAGE = "app/App/RESET_DELETE_MESSAGE";

/**
 * Treatments for the calendar
 */
export const GET_TREATMENTS_ACTION = `${scope}/GET_TREATMENTS_ACTION`;
export const GET_TREATMENTS_FAILED_ACTION = `${scope}/GET_TREATMENTS_FAILED_ACTION`;
export const GET_TREATMENTS_SUCCESS_ACTION = `${scope}/GET_TREATMENTS_SUCCESS_ACTION`;

export const GET_PRODUCT_ORDERS_ACTION = `${scope}/GET_PRODUCT_ORDERS_ACTION`;
export const GET_PRODUCT_ORDERS_FAILED_ACTION = `${scope}/GET_PRODUCT_ORDERS_FAILED_ACTION`;
export const GET_PRODUCT_ORDERS_SUCCESS_ACTION = `${scope}/GET_PRODUCT_ORDERS_SUCCESS_ACTION`;

export const GET_ACTIVE_START_DATE = `${scope}/GET_ACTIVE_START_DATE`;
export const NEXT_MONTH = `${scope}/NEXT_MONTH`;
export const PREVIOUS_MONTH = `${scope}/PREVIOUS_MONTH`;
export const SET_DATE = `${scope}/SET_DATE`;

export const GET_PRACTICE_PRODUCT_ORDERS = `${scope}/GET_PRACTICE_PRODUCT_ORDERS`;
export const GET_PRACTICE_PRODUCT_ORDERS_ERROR = `${scope}/GET_PRACTICE_PRODUCT_ORDERS_ERROR`;
export const GET_PRACTICE_PRODUCT_ORDERS_SUCCESS = `${scope}/GET_PRACTICE_PRODUCT_ORDERS_SUCCESS`;

/**
 * Messages
 */

export const GET_PRACTICE_MESSAGES = `${scope}/GET_PRACTICE_MESSAGES`;
export const GET_PRACTICE_MESSAGES_SUCCESS = `${scope}/GET_PRACTICE_MESSAGES_SUCCESS`;
export const GET_PRACTICE_MESSAGES_ERROR = `${scope}/GET_PRACTICE_MESSAGES_ERROR`;

/**
 * Other
 */

export const PURGE_DELETED_TIME_SLOTS = "app/App/PURGE_DELETED_TIME_SLOTS";

/**
 * Urls
 */
export const END_PRODUCTS_URL = "/endProductTypes";
export const INSURER_URL = "/insurers";

export function PLANNED_TIMESLOTS_URL() {
  return `/practices/${getPractice().id}/plannedTimeSlots`;
}

export function PATIENTS_URL() {
  return `/practices/${getPractice().id}/patients`;
}

export function DENTISTS_URL() {
  return `/practices/${getPractice().id}/dentists`;
}

export function FILTERED_PATIENTS_URL() {
  return `/practices/${getPractice().id}/patients/filter`;
}

export function FILTERED_DENTIST_URL() {
  return `/practices/${getPractice().id}/dentists/filter`;
}

export function FILTER_APPOINTMENTS_URL() {
  return `/practices/${getPractice().id}/plannedTreatments/filter`;
}

export function DELETE_DENTIST_URL() {
  return `/practices/${getPractice().id}/dentists`;
}

export function PRODUCT_ORDER_URL() {
  return `/practices/${getPractice().id}/productOrders`;
}
